import { Model } from 'pinia-orm';

export default class Channel extends Model {

    static get entity() {
        return 'channels'
    }

    static fields() {
        return {
            id: this.uid(),
            name: this.attr(''),
            summary: this.attr(''),
            logo_url: this.attr(''),
            highlighted: this.attr(''),
            brockmeyer_channel_id: this.attr(''),
            channel_type: this.attr(''),
            clicks_cpc_expected: this.attr(''),
            clicks_daily_avg_expected: this.attr(''),
            clicks_expected: this.attr(''),
            clicks_apply_expected: this.attr(0),
            days_online: this.attr(''),
            list_price: this.attr(''),
            price: this.attr(''),
            url: this.attr(''),
            is_intern: this.attr(''),
            ranking: this.attr(0),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            educations: this.attr([]),
            sectors: this.attr([]),
            job_profiles: this.attr([]),
            regions: this.attr([]),
            is_url_example: this.attr(false),
            page: this.attr(),
            booster_id: this.number(null),
            suggestion_score: this.number(null),

            fetched_at: this.attr(null)
        }
    }

    get _id() {
        return this.brockmeyer_channel_id;
    }
}
